import findKey from 'lodash/findKey';
import get from 'lodash/get';

import { MENU_ITEMS_DETAIL as entity } from 'bento-ordering/menus/constants/entities';
import bentoApi, {
  getItemByIdSelector
} from 'bento-ordering/base/reducers/bentoApi';

const apiReducer = bentoApi(entity);
export default apiReducer;

/* ==== SELECTORS ==== */

export const getMenuItemImage = state => get(state.images, '[0].url', '');

export const getMenuItem = (state, menuItemSlug) => {
  const foundId = findKey(state.byId, value => {
    return value.slug === menuItemSlug;
  });

  const menuItem = getItemByIdSelector(state, foundId);
  return menuItem;
};

export const getMenuItemByProductId = (state, id) => {
  const menuItem = getItemByIdSelector(state, id);
  return menuItem;
};
